import MoveFileDialog from './MoveFileDialog';

export default MoveFileDialog;
